import { isEmptyString } from '@/utils/string';
import type { Domain } from '@/services/db/domain/entity';
import type { DomainsList } from '@/services/db/domain/queries';

function hasDomainName(domain: Domain): boolean {
  return !isEmptyString(domain.domain);
}

function isVerifiedDomain(domain: Domain): boolean {
  return domain.verified === true;
}

function selectDomain(domains: readonly Domain[]): Domain | null {
  const namedDomains = domains.filter(hasDomainName);

  return namedDomains.find(isVerifiedDomain) ?? namedDomains[0] ?? null;
}

export function selectSandboxSendingDomain(data: DomainsList): string | null {
  return selectDomain(data.domains)?.domain ?? null;
}
